export default __webpack_public_path__ + "static/media/panda.9dedd285.png";